export interface CostRulesModel {
  amount: number;
  amountCurrency: string;
  descriptionFixedAmount: string;
  descriptionPercentage: string;
  gfhAccountId: number;
  id: string;
  maxTransactionsFixedAmount: number;
  maxTransactionsPercentage: number;
  maximumAmount: number;
  minimumAmount: number;
  moment: number;
  percentage: number;
  percentageAmountOrder: number;
  productVersionId: string;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
}

export class CostRules {
  amount = -1;
  amountCurrency = "";
  descriptionFixedAmount = "";
  descriptionPercentage = "";
  gfhAccountId = -1;
  id = "";
  maxTransactionsFixedAmount = -1;
  maxTransactionsPercentage = -1;
  maximumAmount = -1;
  minimumAmount = -1;
  moment = -1;
  percentage = -1;
  percentageAmountOrder = -1;
  productVersionId = "";
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";

  constructor(dto?: CostRulesModel) {
    if (!dto) {
      return;
    }
    this.amount = dto.amount;
    this.amountCurrency = dto.amountCurrency;
    this.descriptionFixedAmount = dto.descriptionFixedAmount;
    this.descriptionPercentage = dto.descriptionPercentage;
    this.gfhAccountId = dto.gfhAccountId;
    this.id = dto.id;
    this.maxTransactionsFixedAmount = dto.maxTransactionsFixedAmount;
    this.maxTransactionsPercentage = dto.maxTransactionsPercentage;
    this.maximumAmount = dto.maximumAmount;
    this.minimumAmount = dto.minimumAmount;
    this.moment = dto.moment;
    this.percentage = dto.percentage;
    this.percentageAmountOrder = dto.percentageAmountOrder;
    this.productVersionId = dto.productVersionId;
    this.utcInsertDate = dto.utcInsertDate;
    this.utcUpdateDate = dto.utcUpdateDate;
    this.version = dto.version;
  }
}
